import MyAppointments from '../../components/expert/MyAppointments';

const MyAppointmentsDetailsPage = () => {
    return(
        <MyAppointments/>
    )
}

export default MyAppointmentsDetailsPage;